import { MinusOutlined, PlusOutlined } from '@ant-design/icons';
import { Collapse, Typography } from 'antd';
import React, { useState } from 'react';
import * as S from './DealRoomSection.styles';

const { Title, Text } = Typography;
export const { Panel } = Collapse;

export interface PanelItem {
  key: string;
  title: string;
  content: React.ReactNode;
}
const InsuranceCover: React.FC = () => {
  return (
    <>
      <S.ContentTextWrapper>
        <Text className="sub-text">
          {`ביטוח צד ג' מכסה אירועי תאונה בגוף או ברכוש הנובעים מרשלנות של הוועד ובעלי הדירות בניהול ותחזוקה של השטחים המשותפים. מי שיכול לתבוע את הפוליסה הם דיירים ודיירות או אורחים ואורחות בבניין.`}
        </Text>
      </S.ContentTextWrapper>

      <S.ContentTextWrapper>
        <Title level={2} className="main-title regular">
          {`במקרה של תביעה:`}
        </Title>
        <Text className="sub-text">
          {`אם הוועד נתבע בטענה שנגרמה תאונה בעקבות רשלנות של הוועד בטיפול ברכוש המשותף, הוועד יקבל ליווי משפטי לכל אורך התהליך, גם אם בסופו של דבר יוכח שהוועד לא התרשל.`}
        </Text>
      </S.ContentTextWrapper>

      <S.ContentTextWrapper>
        <Title level={2} className="main-title regular">
          {`במקרה של תשלום:`}
        </Title>
        <Text className="sub-text">
          {`הביטוח מספק כיסוי של 5 מיליון ₪ או יותר, בהתאם לפוליסה ולהרחבות שנבחרו. הרחבות אלו יכולות להתייחס לשטחי מסחר, מכפילי חנייה, חדר כושר, בריכה, ג'קוזי, סאונה, מתקני משחקים ועוד.`}
        </Text>
      </S.ContentTextWrapper>

      <S.ContentTextWrapper className="mt-24">
        <Title level={2} className="main-title regular">
          {`מקרים ביטוחיים לדוגמה:`}
        </Title>
        <S.ListWrapper>
          <S.ListItem>{`שריפה שמקורה בלוח החשמל הראשי של הבניין גרמה לנזקים כבדים לדירות.`}</S.ListItem>
          <S.ListItem>{`דייר שמעד בבור קטן בגינה או בשביל הגישה לבניין ושבר את הרגל.`}</S.ListItem>
        </S.ListWrapper>
        <Text className="sub-text">
          {`בשני המקרים, אם התאונה התרחשה כתוצאה מרשלנות של הוועד, ביטוח צד ג' מלווה את ועד הבית בכל ההליך ומפצה את התובעים. תביעות אלו ורבות אחרות עלולות להגיע לסכומים מאוד גבוהים של מאות אלפי שקלים ואף מיליוני שקלים ולכן חשוב מאוד להיות מבוטחים.`}
        </Text>
      </S.ContentTextWrapper>
    </>
  );
};
const InsuranceNotCover: React.FC = () => {
  return (
    <>
      <S.ContentTextWrapper>
        <Text className="sub-text">
          {`ביטוח צד ג' לא מכסה מקרים שאינם תאונות או מקרים שלא התרחשו כתוצאה מרשלנות של ועד הבית.`}
        </Text>
      </S.ContentTextWrapper>

      <S.ContentTextWrapper className="mt-24">
        <Title level={2} className="main-title regular">
          {`מקרים ביטוחיים לדוגמה:`}
        </Title>
        <S.ListWrapper>
          <S.ListItem>{`אורח נכנס ללובי ולקה באירוע לב. היות שלא מדובר בתאונה, אין עילה משפטית לתבוע את ועד הבית.`}</S.ListItem>
          <S.ListItem>{`ביום גשום וסוער נוצרה סתימה בניקוז הראשי של הרחוב שהובילה להצפת החניון התת קרקעי.`}</S.ListItem>
        </S.ListWrapper>
        <Text className="sub-text">
          {`במקרה זה לא מדובר בתאונה שהתרחשה בעקבות רשלנות של הוועד ולכן הביטוח לא מכסה את הנזקים.`}
        </Text>
      </S.ContentTextWrapper>
    </>
  );
};
const FAQs: React.FC = () => {
  return (
    <>
      <S.ContentTextWrapper>
        <S.ListWrapper className="number">
          <S.ListItem>
            <S.ListTitle>{`אחת הדיירות נפלה בחדר מדרגות בגלל שלולית מים, האם היא יכולה לתבוע את
ביטוח צד ג'?`}</S.ListTitle>
            <S.ListContent>{`כן, ביטוח צד ג' מכסה מקרה בו דייר או אורח נפגעים כתוצאה מהרכוש המשותף ותובעים את הבניין. הייחודיות בפוליסת בית משותף היא שלמרות שהדייר הוא חלק מהבעלים של הבניין הוא עדיין נחשב צד ג'. לכן, גם אם הוא תובע את הבניין, ביטוח צד ג' יגן על הבניין.`}</S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListTitle>{`האם ביטוח צד ג' נותן כיסוי מלא לבניין?`}</S.ListTitle>
            <S.ListContent>{`לא. ביטוח צד ג' מכסה את הבניין כנגד תביעות של אורחים ודיירים, אך אינו מכסה נזקים לרכוש המשותף. ניתן להשוות את ביטוח הבניין לביטוח רכב. מרבית האנשים מבטחים את רכבם בביטוח צד ג' וביטוח מקיף כדי שבמקרה של תאונה יהיה כיסוי כנגד תביעה משפטית מהנפגע (צד ג') ופיצוי עבור הנזק התאונתי שנגרם לרכב (מקיף).`}</S.ListContent>
          </S.ListItem>
          <S.ListItem>
            <S.ListTitle>{`אם רכוש פרטי נפגע מקטסטרופה ברכוש המשותף, האם הרכוש הפרטי מכוסה?`}</S.ListTitle>
            <S.ListContent>{`כן, ביטוח צד ג' יגן על הבניין במידה ונגרם נזק לרכוש פרטי כאשר גורם הנזק הוא הרכוש המשותף. אם למשל קצר בלוח חשמל ראשי של הבניין יגרום לשריפה ויינזקו מספר דירות בבניין, ובעלי הדירות (או חברת הביטוח של בעלי הדירות) ייתבעו את הבניין, ביטוח צד ג׳ יגן עליו.`}</S.ListContent>
          </S.ListItem>
        </S.ListWrapper>
      </S.ContentTextWrapper>
    </>
  );
};

const panelItems: PanelItem[] = [
  {
    key: 'מה הביטוח מכסה?',
    title: 'מה הביטוח מכסה?',
    content: <InsuranceCover />,
  },
  {
    key: 'מה הביטוח לא מכסה?',
    title: 'מה הביטוח לא מכסה?',
    content: <InsuranceNotCover />,
  },
  {
    key: 'שאלות ותשובות נפוצות',
    title: 'שאלות ותשובות נפוצות',
    content: <FAQs />,
  },
];

export const ThirdPartyInsurance: React.FC = () => {
  const [activeKey, setActiveKey] = useState<string | string[]>();
  return (
    <S.Wrapper>
      <S.Header>
        <Title level={2} className="main-title">
          {`למה צריך ביטוח צד ג' לבית משותף?`}
        </Title>
        <Text className="sub-text">
          {` ביטוח צד ג' הוא הביטוח הבסיסי ביותר לבית משותף. ועד הבית נושא באחריות משפטית על ניהול ותחזוקה של השטחים
          הציבוריים בבית המשותף, ובהיבט הזה הוא דומה לעסק קטן (או אפילו לעסק גדול) שצריך להיערך לנזקי תאונות לא צפויות.`}
        </Text>
      </S.Header>

      <S.IconCollapseWrapper>
        <S.IconCollapse accordion className="custom-collapse" activeKey={activeKey} onChange={setActiveKey}>
          {panelItems.map((item) => (
            <Panel
              key={item.key}
              showArrow={false}
              header={
                <S.PanelHeader>
                  <S.IconWrapper>
                    {activeKey === item.key ? (
                      <MinusOutlined className="plus-icon" />
                    ) : (
                      <PlusOutlined className="plus-icon" />
                    )}
                  </S.IconWrapper>
                  <Text strong className="header-text">
                    {item.title}
                  </Text>
                </S.PanelHeader>
              }
            >
              {item.content}
            </Panel>
          ))}
        </S.IconCollapse>
      </S.IconCollapseWrapper>
    </S.Wrapper>
  );
};
